import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowBottomRightIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.38251 6.38251C6.63446 6.13055 7.04296 6.13055 7.29491 6.38251L16.5161 15.6037V7.87096C16.5161 7.51465 16.805 7.2258 17.1613 7.2258C17.5176 7.2258 17.8065 7.51465 17.8065 7.87096V17.1613C17.8065 17.5176 17.5176 17.8064 17.1613 17.8064H7.87097C7.51466 17.8064 7.22581 17.5176 7.22581 17.1613C7.22581 16.805 7.51466 16.5161 7.87097 16.5161H15.6037L6.38251 7.2949C6.13056 7.04295 6.13056 6.63446 6.38251 6.38251Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowBottomRightIcon)
